import z from 'zod';
import { scopedEntity, schedule, staticResponderRef, multipleEmailString, string, datetime, } from '../common';
export const staticResponderContact = z.object({
    email: multipleEmailString.nullable(),
    phone: string.nullable(),
    sms: string.nullable(),
    camera: string.nullable(),
}).refine((v) => !!(v.email || v.phone || v.sms || v.camera), {
    message: 'At least one contact method must be specified',
});
export const staticResponderSequrixConfig = z.object({
    enabled: z.boolean(),
    objectCode: string,
});
export const staticResponderIntegrations = z.object({
    sequrix: staticResponderSequrixConfig,
});
export const staticResponderStatisticsEntry = z.object({
    timestamp: datetime,
    speedMs: z.number().int().nonnegative(),
});
export const staticResponderStatistics = z.object({
    acceptSpeeds: z.array(staticResponderStatisticsEntry).min(0).max(10),
    onLocationSpeeds: z.array(staticResponderStatisticsEntry).min(0).max(10),
    finishSpeeds: z.array(staticResponderStatisticsEntry).min(0).max(10),
    amountRejected: z.number().int().nonnegative(),
    amountAccepted: z.number().int().nonnegative(),
});
export const staticResponder = z.object({
    ...scopedEntity.shape,
    name: string,
    externalId: string.nullable(),
    contact: staticResponderContact,
    schedule: schedule.nullable(),
    migrationKey: string.optional(),
    integrations: staticResponderIntegrations.optional(),
    statistics: staticResponderStatistics.optional(),
});
export const staticResponderRelation = z.object({
    staticResponder: staticResponderRef,
    priority: z.number(),
});
